module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control button has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;  height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; width:  ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px; z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append(";\">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n        <div class=\"pf-control-core pf-selectable\"\r\n             style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border-radius: 0px;\r\n                border: solid ")
    ; __append(escapeFn(borderColor))
    ; __append(" 1px;\">\r\n            <style>\r\n                #")
    ; __append(escapeFn(id))
    ; __append(" .c3 line, #")
    ; __append(escapeFn(id))
    ; __append(" .c3 path{ stroke:")
    ; __append(escapeFn(axisColor))
    ; __append(" }\r\n                #")
    ; __append(escapeFn(id))
    ; __append(" .c3-axis-y text, #")
    ; __append(escapeFn(id))
    ; __append(" .c3-axis-x text {\r\n                    fill:")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                    font-family:")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                    font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                }\r\n            </style>\r\n            <div class=\"line-chart\">line chart target</div>\r\n        </div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}